import { MULTIPLE_CHOICE, NOTE_IDENTIFICATION } from '@cavaquinho/shared';

/**
 * What an Exercise is CALLED to the learner, by its type.
 *
 * An Exercise has no title of its own — it is a configured instance of a
 * type, and naming each one individually would be authoring busywork that
 * says the same thing every time. So the type carries the name, in
 * Portuguese, like everything else the learner reads.
 *
 * Adding an Exercise Type adds an entry here alongside its handler and its
 * renderer. A missing entry is not a crash: an unknown type falls back to a
 * neutral label, because content can name a type this build has never heard
 * of and a list is not the place to fail over it.
 */
const LABELS: Record<string, string> = {
  [NOTE_IDENTIFICATION]: 'Identificação de nota',
  [MULTIPLE_CHOICE]: 'Múltipla escolha',
};

export function exerciseTypeLabel(exerciseType: string): string {
  return LABELS[exerciseType] ?? 'Exercício';
}
